/**
 * Centralized version management
 * This file is auto-generated from package.json
 * DO NOT EDIT MANUALLY - run 'npm run sync-version' instead
 */
export const APP_VERSION = '1.0.6';
